import React, { useEffect, useState } from 'react';
import '../styles/Home.css';
import { storeLinks } from "../config/storeLinks";
import JamaStoryOutline from '../components/JamaStoryOutline';
import JamaReferralSection from '../components/JamaReferralSection';

function Home() {
    const foodSlides = ['/1.png', '/2.png', '/3.png', '/4.png'];
    const [activeSlide, setActiveSlide] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setActiveSlide((prev) => (prev + 1) % foodSlides.length);
        }, 2600);
        return () => clearInterval(timer);
    }, [foodSlides.length]);

    return (
        <div className="home">

            {/* ═══ STORY KURZGESAGT (human characters) ═════ */}
            <JamaStoryOutline />

            {/* ═══ HERO ══════════════════════════════════════════════ */}
            <section id="hero-main" className="hero">
                <div className="hero__inner">
                    <div className="hero-left">
                        <span className="hero-eyebrow">Descarga la app</span>
                        <h1 className="hero-title">
                            Pide comida y<br /><span className="highlight">mucho más</span>
                        </h1>
                        <p className="hero-subtitle">
                            Haz clic, relájate y disfruta. Restaurantes y tiendas que entregan cerca de ti.
                        </p>
                        <div className="app-buttons">
                            <a
                                href={storeLinks.apple_jama_app}
                                className="app-button store"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src="/apple_logo.png" alt="Apple Logo" className="store-icon" />
                                <div>
                                    <small>Descarga en</small>
                                    <strong>App Store</strong>
                                </div>
                            </a>
                            <a
                                href={storeLinks.play_store_jama_app}
                                className="app-button store"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src="/google_play_logo.png" alt="Google Play" className="store-icon" />
                                <div>
                                    <small>Descarga en</small>
                                    <strong>Google Play</strong>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div className="hero-right">
                        <div className="hero-right__card">
                            <p className="hero-right-title">ALGUIEN HA DICHO<br /><span>¡QUE RICO!</span></p>
                            <div className="hero-dish" role="img" aria-label="Platos destacados">
                                {foodSlides.map((src, index) => (
                                    <img
                                        key={src}
                                        src={src}
                                        alt={`Plato ${index + 1}`}
                                        className={`hero-slide ${index === activeSlide ? 'is-active' : ''}`}
                                    />
                                ))}
                            </div>
                            <div className="hero-food-badges">
                                {foodSlides.map((_, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className={`hero-slide-dot ${index === activeSlide ? 'is-active' : ''}`}
                                        aria-label={`Ver plato ${index + 1}`}
                                        onClick={() => setActiveSlide(index)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══ SLOGAN BANNER ══════════════════════════════════ */}
            <section className="slogan">
                <div className="slogan__inner">
                    <blockquote className="slogan__quote">
                        "Todo lo cool está en <span className="slogan__brand">Jama</span>"
                    </blockquote>
                </div>
            </section>

            {/* ═══ REFERRAL SECTION (animated Kurzgesagt) ═════════ */}
            <JamaReferralSection />

            {/* ═══ TIKTOK FEATURE ════════════════════════════════════ */}
            <section className="feats">
                <div className="feats__inner">
                    <div className="feats__grid feats__grid--single">

                        <div className="feat feat--tt">
                            <div className="feat__dots" aria-hidden="true"></div>
                            <div className="feat__pill feat__pill--ghost">¡Contenido viral premiado con dinero!</div>
                            <div className="feat__logoRow" aria-hidden="true">
                                <span className="feat__ttLogo">TikTok</span>
                                <span className="feat__plus">+</span>
                                <span className="feat__jamaLogo">JAMA</span>
                            </div>
                            <h3 className="feat__title">Sube tu contenido</h3>
                            <p className="feat__desc">
                                Crea tu video, nosotros lo hacemos viral. Sube contenido con nuestro logo
                                y llega a miles de foodies en toda la ciudad.
                            </p>
                            <ul className="feat__list">
                                <li>Logo oficial de JAMA</li>
                                <li>Boost de alcance</li>
                                <li>Comunidad foodie</li>
                            </ul>
                            <button className="feat__btn feat__btn--light" type="button" disabled>Ingresa a tu app favorita y empieza</button>
                            <div className="feat__sticker feat__sticker--2" aria-hidden="true"><span>VIRAL!</span></div>
                        </div>

                    </div>
                </div>
            </section>

        </div>
    );
}

export default Home;
